import { Injectable } from '@angular/core';
import { Screenshot } from '@ionic-native/screenshot';
import { Platform } from 'ionic-angular';
import { File } from '@ionic-native/file';
import { GlobalServiceProvider } from '../providers/global-service/global-service';

declare const cordova;
declare const greatdayplugin;
@Injectable()
export class ScreenshotNative {
  constructor(
    private readonly screenshot: Screenshot,
    private readonly platform: Platform,
    private readonly file: File,
    private readonly globalServiceProvider: GlobalServiceProvider,
  ) {
  }

  save(setting: SaveScreenShot): Promise<ResultScreenShot> {
    return new Promise((resolve, reject) => {
      this.screenshot.save(setting.format, setting.quality, setting.filename).then(success => resolve(success), error => reject(error))
    })
  }

  getDataURI(quality?: number): Promise<ResultScreenShotURI> {
    return new Promise((resolve, reject) => {
      this.screenshot.URI(quality).then(success => resolve(success), error => reject(error))
    })
  }

  saveDataURI(fileName: string, quality?: number): Promise<ResultScreenShot> {
    return new Promise(async (resolve, reject) => {
      try {
        let localPath = '';
        if (this.platform.is('android')) {
          localPath = this.file.externalRootDirectory + 'Download/GreatDayHr/';
        } else if (this.platform.is('ios')) {
          localPath = cordova.file.cacheDirectory + '/';
        }
        const extension = '.jpg';
        const result = await this.getDataURI(quality);
        const blob: any = await this.globalServiceProvider.convertBase64toBlob(result.URI);
        await this.file.writeFile(localPath, fileName + extension, blob, { replace: true })
        resolve({ filePath: localPath + fileName + extension });
      } catch (e) {
        reject(e);
      }
    })
  }

  async enableScreenshot() {
    try {
      await this.platform.ready();
      if (this.platform.is('cordova') && this.platform.is('android')) {
        (<any>window).plugins.preventscreenshot.enable((a) => (result) => { console.log(result); }, (b) => (result) => { console.log(result); });
      } else if (this.platform.is('cordova') && this.platform.is('ios')) {
        greatdayplugin.removeBlurredSnapshot();
      }
    } catch (error) { }
  }

  async disabledScreenshot() {
    try {
      await this.platform.ready();
      if (this.platform.is('cordova') && this.platform.is('android')) {
        (<any>window).plugins.preventscreenshot.disable((a) => (result) => { console.log(result); }, (b) => (result) => { console.log(result); });
      } else if (this.platform.is('cordova') && this.platform.is('ios')) {
        greatdayplugin.addBlurredSnapshot();
      }
    } catch (error) { }
  }
}

interface SaveScreenShot {
  format?: 'jpg';
  quality?: number;
  filename?: string;
}

interface ResultScreenShot {
  filePath: string;
}

interface ResultScreenShotURI {
  URI: string;
}



// WEBPACK FOOTER //
// ./src/native/screenshot.native.ts